const { cxt } = require('./context');

const {
  sales,
} = require('../schema');

const {
  vx,
} = sales;

/**
 * Validates the VX Repayment Calculator from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const salesVxRepaymentCalculatorValidator = [
  cxt('schema', { schema: vx.repaymentCalculator }),
];

module.exports = {
  salesVxRepymentCalculator: salesVxRepaymentCalculatorValidator,
};
